import { getJson } from './http';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

export async function listImageHistory({ tenant, limit = 100, offset = 0 }) {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  // No headers; pass tenant in the URL like the rest of your API
  return getJson(`/api/history/${tenant}/images?${q.toString()}`);
}

export async function getPublicHistoryEnabled(tenant) {
  return getJson(`/api/history/${tenant}/public-history-enabled`);
}

export async function togglePublicVisibility(tenant, itemId, show) {
  const res = await fetch(`${BASE_URL}/api/history/${tenant}/items/${itemId}/public-visibility`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ show }),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}
